export default __webpack_public_path__ + "static/media/property_66.61552de6.png";